<template>
    <v-card xs12 flat>
        <v-card-title><h1 class="headline">General</h1></v-card-title>
        <v-card-text>
            <v-layout row wrap>
                <v-flex class="pa-3" v-for="item in Documents">
                    <v-card>
                        <v-card-title style="text-align:center;display:inherit;" class="text-center">{{item.Title}}</v-card-title>
                        <v-card-text>
                            <v-list>
                                <template v-for="i in item.Docs">
                                    <v-divider class="ma-0" v-if="createURL(i) != '#' && (i.Name != 'Public Participation' || Session.SpecialSession != true)"></v-divider>
                                    <v-list-item rel="noopener" :href="createURL(i)" :key="i.Name" v-if="createURL(i) != '#' && (i.Name != 'Public Participation' || Session.SpecialSession != true)">
                                        <v-list-item-content :name="i.Name">
                                            <v-list-item-title>
                                                {{i.Name}} <span v-if="i.url.includes('.pdf')"><sup>(PDF)</sup></span>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-list>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>
<script>
    export default {
        name: 'General',
        props: ['SessionId'],
        components: {

        },
        methods: {
            LoadData()
            {
                fetch('/api/Sessions/' + this.SessionId,
                    {
                        method: "GET",
                        credentials: "include",
                        headers: { "Content-Type": "application/json" },
                    })
                    .then(res =>
                    {
                        if (res.ok)
                            return res.json();
                        else
                            throw new Error(res.statusText);
                    })
                    .then(response =>
                    {
                        this.Session = EncodeDatetimes(response);
                    })
                    .catch(error =>
                    {
                        throw new Error(error);
                    });

                fetch('/api/Sessions/General/' + this.SessionId,
                    {
                        method: "GET",
                        credentials: "include",
                        headers: { "Content-Type": "application/json" },
                    })
                    .then(res =>
                    {
                        this.loading = false;

                        if (res.ok)
                            return res.json();
                        else
                            throw new Error(res.statusText);
                    })
                    .then(response =>
                    {
                        this.items = EncodeDatetimes(response);

                        let sr = this.Documents.find(x => x.Title == 'Session Resources');
                        let l = this.Documents.find(x => x.Title == 'Leadership');
                        let r = this.Documents.find(x => x.Title == 'Rules');

                        sr.Docs.filter(x => x.Name == 'Committee Schedule & Staff Assignments')[0].url = this.createMYLRCLink(this.items.find(x => x.Filename == 'lrcstaff.pdf'));
                        sr.Docs.filter(x => x.Name == 'Legislative Guide')[0].url = this.createMYLRCLink(this.items.find(x => x.Filename == 'guide.pdf'));
                        sr.Docs.filter(x => x.Name == 'Legislative Index')[0].url = this.createMYLRCLink(this.items.find(x => x.Filename == 'legislativeindex.pdf'));
                        sr.Docs.filter(x => x.Name == 'Legislator Reference Book')[0].url = this.createMYLRCLink(this.items.find(x => x.Filename == 'legislatorreferencebook.pdf'));
                        sr.Docs.filter(x => x.Name == 'Redbook')[0].url = this.createMYLRCLink(this.items.find(x => x.Filename.includes('redbook.pdf')));
                        sr.Docs.filter(x => x.Name == 'Seating Arrangement - House')[0].url = this.createMYLRCLink(this.items.find(x => x.Filename == 'houseseatingchart.pdf'));
                        sr.Docs.filter(x => x.Name == 'Seating Arrangement - Senate')[0].url = this.createMYLRCLink(this.items.find(x => x.Filename == 'senateseatingchart.pdf'));
                        sr.Docs.filter(x => x.Name == 'Session Calendar')[0].url = this.createMYLRCLink(this.items.find(x => x.Filename == 'calendar.pdf'));

                        l.Docs.filter(x => x.Name == 'Legislative Leadership')[0].url = this.createMYLRCLink(this.items.find(x => x.Filename == 'leaders.pdf'));
                        l.Docs.filter(x => x.Name == 'House Chairs/Leadership Directory')[0].url = this.createMYLRCLink(this.items.find(x => x.Filename == 'housedirectory.pdf'));
                        l.Docs.filter(x => x.Name == 'Senate Chairs/Leadership Directory')[0].url = this.createMYLRCLink(this.items.find(x => x.Filename == 'senatedirectory.pdf'));

                        r.Docs.filter(x => x.Name == 'Joint Rules')[0].url = this.createMYLRCLink(this.items.find(x => x.Filename == 'jointrules.pdf'));
                        r.Docs.filter(x => x.Name == 'House Rules')[0].url = this.createMYLRCLink(this.items.find(x => x.Filename == 'houserules.pdf'));
                        r.Docs.filter(x => x.Name == 'Senate Rules')[0].url = this.createMYLRCLink(this.items.find(x => x.Filename == 'senaterules.pdf'));
                        r.Docs.filter(x => x.Name == 'Special Session Rules')[0].url = this.createMYLRCLink(this.items.find(x => x.DocumentTypeId == 112));

                        //this.UpdateRow(r.Docs.find(x => x.Name == 'Participate Remotely'), this.createMYLRCLink(this.items.find(x => x.DocumentTypeId == 112)));
                        //.url = this.createMYLRCLink(this.items.find(x => x.Filename == 'senaterules.pdf'));

                        //Participate Remotely
                    })
                    .catch(error =>
                    {
                        throw new Error(error);
                    });
            },
            createMYLRCLink(obj)
            {
                if (obj != null)
                {
                    return this.$MyLRCUrl.value + 'api/Documents/' + obj.DocumentId + '.pdf';
                } else
                {
                    return "#";
                }

            },
            createURL(i)
            {
                if (i.includeSessionId == true)
                {
                    return i.url + this.SessionId;
                }
                else
                {
                    return i.url;
                }
            },
            UpdateRow(row, url)
            {
                if (row)
                {
                    if (url)
                    {

                    }
                }
            },
        },
        data: function ()
        {
            return {
                Session: {},
                Documents: [
                    {
                        Title: 'Session Resources',
                        Docs: [
                            {
                                Name: 'Committee Schedule & Staff Assignments',
                                url: '#doc.pdf',
                                hidden: false,
                            },
                            {
                                Name: 'Legislative Guide',
                                url: '#doc.pdf',
                                hidden: false,
                            },
                            {
                                Name: 'Legislative Index',
                                url: '#doc.pdf',
                                hidden: false,
                            },
                            {
                                Name: 'Legislator Reference Book',
                                url: '#doc.pdf',
                                hidden: false,
                            },
                            {
                                Name: 'Lobbyist Listing',
                                url: 'https://sosenterprise.sd.gov/BusinessServices/Lobbyist/LobbyistSearch.aspx',
                                hidden: false,
                            },
                            {
                                Name: 'Redbook',
                                url: '#doc.pdf',
                                hidden: false,
                            },
                            {
                                Name: 'Seating Arrangement - House',
                                url: '#doc.pdf',
                                hidden: false,
                            },
                            {
                                Name: 'Seating Arrangement - Senate',
                                url: '#doc.pdf',
                                hidden: false,
                            },
                            {
                                Name: 'Session Calendar',
                                url: '#doc.pdf',
                                hidden: false,
                            },
                            {
                                Name: 'Staff Subject Areas',
                                url: '/Staff/SubjectArea',
                                hidden: false,
                            },
                            {
                                Name: 'Housing Questionnaire',
                                url: '/Session/Housing',
                                hidden: false,
                            },
                            {
                                Name: 'Public Participation',
                                url: 'https://mylrc.sdlegislature.gov/api/documents/212840.pdf',
                                hidden: false,
                            },
                        ],
                    },
                    {
                        Title: 'Leadership',
                        Docs: [
                            {
                                Name: 'Legislative Leadership',
                                url: '#doc.pdf',
                                hidden: false,
                            },
                            {
                                Name: 'House Chairs/Leadership Directory',
                                url: '#doc.pdf',
                                hidden: false,
                            },
                            {
                                Name: 'Senate Chairs/Leadership Directory',
                                url: '#doc.pdf',
                                hidden: false,
                            },
                        ],
                    },
                    {
                        Title: 'Rules',
                        Docs: [
                            {
                                Name: 'Joint Rules',
                                url: '#doc.pdf',
                                hidden: false,
                            },
                            {
                                Name: 'House Rules',
                                url: '#doc.pdf',
                                hidden: false,
                            },
                            {
                                Name: 'Senate Rules',
                                url: '#doc.pdf',
                                hidden: false,
                            },
                            {
                                Name: 'Special Session Rules',
                                url: '#doc.pdf',
                                hidden: false,
                            },
                        ],
                    },

                    {
                        Title: 'Media',
                        Docs: [
                            {
                                Name: 'Memorial Service',
                                url: '/Session/Memorial',
                                hidden: false,
                            },
                            {
                                Name: 'Podcast Feeds',
                                url: '/Session/Committees/',
                                includeSessionId: true,
                                hidden: false,

                            },
                            {
                                Name: 'RSS Feeds',
                                url: '/Session/Committees/',
                                includeSessionId: true,
                                hidden: false,
                            },
                        ],
                    }
                ],
                items: [],
            }
        },
        mounted: function ()
        {
            this.LoadData();
        },
        watch: {
            SessionId: function ()
            {
                this.LoadData();
            }
        },
        computed: {
            Title: function ()
            {
                let title = 'General Information';
                if (this.Session && this.Session.Year)
                {
                    title = this.Session.Year + " General Information";
                }
                return title;
            },
            Description: function ()
            {
                return this.Title;
            }
        },
        metaInfo()
        {
            return {
                title: this.Title,
                meta: [
                    { vmid: 'description', name: 'description', content: this.Description },
                    // OpenGraph data (Most widely used)
                    { vmid: 'og:title', property: 'og:title', content: this.Title + ' | South Dakota Legislature' },
                    // The list of types is available here: http://ogp.me/#types
                    { vmid: 'og:type', property: 'og:type', content: 'website' },
                    // Should be the same as your canonical link, see below.
                    { vmid: 'og:url', property: 'og:url', content: window.location.href },
                    // Often the same as your meta description, but not always.
                    { vmid: 'og:description', property: 'og:description', content: this.Description },

                    // Twitter card
                    { vmid: 'twitter:card', name: 'twitter:card', content: 'summary' },
                    { vmid: 'twitter:site', name: 'twitter:site', content: window.location.href },
                    { vmid: 'twitter:title', name: 'twitter:title', content: this.Title + ' | South Dakota Legislature' },
                    { vmid: 'twitter:description', name: 'twitter:description', content: this.Description }
                ],
                link: [
                    { vmid: 'canonical', rel: 'canonical', href: window.location.href.split('?')[0] }
                ]
            }
        }
    };
</script>
<style></style>